<template>
  <div>
    <div>
      <h4 class="text-center text-lighter font-weight-normal mt-5 mb-0">Create an Workspace</h4>
      <!-- Form -->
      <form class="my-5">
        <b-form-group label="Workspace name" :feedback="errors.name">
          <b-input v-model="credentials.name" :state="!errors.name" />
        </b-form-group>
        <b-form-group label="Workspace url">
          <b-input-group :append="`.${frontDomain}`">
            <b-input v-model="credentials.domain" :state="!errors.domain" />
          </b-input-group>
          <div role="alert" aria-live="assertive" aria-atomic="true" class="invalid-feedback" v-if="errors.domain" style="display: block">
            {{ errors.domain }}
          </div>
        </b-form-group>
        <b-form-group label="Your email" :feedback="errors.email" :invalid-feedback="errors.email">
          <b-input v-model="credentials.email" :state="!errors.email" />
        </b-form-group>
        <b-form-group label="Password" :feedback="errors.password" :invalid-feedback="errors.password">
          <b-input type="password" v-model="credentials.password" :state="!errors.password" />
        </b-form-group>
        <b-btn variant="primary" :block="true" class="mt-4" @click="register">Create</b-btn>
        <div class="text-light small mt-4">
          By clicking "Create", you agree to our
          <a href="javascript:void(0)">terms of service and privacy policy</a>. We’ll occasionally send you account related emails.
        </div>
      </form>
      <!-- / Form -->

      <div class="text-center text-muted">
        Already have an workspace?
        <router-link :to="{ name: 'login' }">Sign In</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'register',
  data: () => ({
    isDone: false,
    credentials: {
      name: '',
      email: '',
      password: '',
      domain: ''
    },
    errors: {
      name: '',
      email: '',
      password: '',
      domain: ''
    }
  }),
  computed: {
    ...mapGetters(['frontDomain'])
  },
  methods: {
    ...mapActions('auth', {
      _register: 'register'
    }),
    clearErrors() {
      for (let f in this.errors) {
        if (Object.hasOwn(this.errors, f)) {
          this.errors[f] = ''
        }
      }
    },
    register() {
      this.clearErrors()
      this._register(this.credentials).then((r) => {
          window.location = `https://${this.credentials.domain}.${this.frontDomain}/register-verification`
        }, (error) => {
          let data = error.response.data
          if (data.errors) {
            for (let field in data.errors) {
              Vue.set(this.errors, field, data.errors[field].join('; '))
            }
          }
        })
    }
  }
}
</script>

<style scoped></style>
